import React, { useEffect } from "react";
import BlogBanner from "./BlogBanner/BlogBanner";
import BlogSection from "./BlogSection/BlogSection";
import Nav from "../Home/navbar/nav";
import { Helmet } from "react-helmet";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const Insights = () => {
useEffect(() => {
  const ctx = gsap.context(() => {
    gsap.set(".blog-banner-title, .blog-banner-description", {
      opacity: 1,
      y: 0,
    });

    gsap.fromTo(
      ".blog-section-heading",
      {
        opacity: 0,
        y: 60,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".blog-section-heading",
          start: "top 85%",
          toggleActions: "play none none reverse",
        },
      }
    );
  });

  return () => {
    ctx.revert();
  };
}, []);

  return (
    <>
      <Helmet>
        <title>Insights | Althi Solutions</title>
        <meta
          name="description"
          content="Discover the Best Stories from Our Bloggers!"
        />
        <link rel="canonical" href="https://www.althisolutions.com/blog" />
        <meta name="robots" content="index, follow" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Insights | Althi Solutions" />
        <meta
          property="og:description"
          content="Discover the Best Stories from Our Bloggers!"
        />
        <meta
          property="og:url"
          content="https://www.althisolutions.com/blog"
        />
        <meta
          property="og:image"
          content="https://www.althisolutions.com/thumbnail.jpg"
        />
        <meta
        property="og:site_name"
        content="Althi Solutions"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:site"
          content="@AlthiSolutions"
        />
        <meta
          name="twitter:creator"
          content="@AlthiSolutions"
          />
        <meta name="twitter:title" content="Insights | Althi Solutions" />
        <meta
          name="twitter:description"
          content="Discover the Best Stories from Our Bloggers!"
        />
        <meta
          name="twitter:image"
          content="https://www.althisolutions.com/thumbnail.jpg"
        />
      </Helmet>

      <Nav />
      <BlogBanner />
      <BlogSection />
    </>
  );
};

export default Insights;
